<template>
  <div>
    <slot :handleButtonClick="handleAddCard"/>
    <div v-if="organization">
      <b-modal v-model="paymentMethodModal" title="Add Payment Method" hide-footer>
        <payment-method-form :organization="organization"
                             :payment-methods-url="paymentMethodsUrl"
                             @success="handleAddedPaymentMethod"
                             @cancel="paymentMethodModal = false"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import PaymentMethod from "./PaymentMethod";
import PaymentCardForm from "../Payments/PaymentCardForm";
import OrganizationBillingFormInputs from "../Billing/OrganizationBillingFormInputs";
import PaymentMethodForm from "./PaymentMethodForm.vue";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default {
  components: {OrganizationBillingFormInputs, PaymentCardForm, PaymentMethod, PaymentMethodForm},

  mixins: [GeneralMixins],

  data: function () {
    return {
      paymentMethodModal: false,
      paymentMethodsUrl: "/customers/payment_methods",
      organization: null
    }
  },

  async mounted() {
    this.organization = await OrganizationsApi.getOrganization()
  },

  methods: {
    handleAddCard() {
      this.paymentMethodModal = true;
    },

    handleAddedPaymentMethod(paymentMethod) {
      this.paymentMethodModal = false
      window.location.reload()
    }
  }
}
</script>
